import { render, staticRenderFns } from "./newsAdd.vue?vue&type=template&id=502b308f&scoped=true"
import script from "./newsAdd.vue?vue&type=script&lang=js"
export * from "./newsAdd.vue?vue&type=script&lang=js"
import style0 from "./newsAdd.vue?vue&type=style&index=0&id=502b308f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b308f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('502b308f')) {
      api.createRecord('502b308f', component.options)
    } else {
      api.reload('502b308f', component.options)
    }
    module.hot.accept("./newsAdd.vue?vue&type=template&id=502b308f&scoped=true", function () {
      api.rerender('502b308f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/competition/newsAdd.vue"
export default component.exports